const ONE_SIGNAL_EMBED = {
  ONE_SIGNAL_EMBED_EMBED_IMPRESSION: 'ONE_SIGNAL_CUSTOM_LINK_EMBED_IMPRESSION',
  ONE_SIGNAL_EMBED_EMBED_CLICK: 'ONE_SIGNAL_CUSTOM_LINK_EMBED_CLICK'
};

export {ONE_SIGNAL_EMBED};
